<template>
  <TransitionGroup
    appear
    name="staggered-transition"
    :tag="tag"
    :class="className"
    :css="false"
    @before-enter="beforeEnter"
    @enter="enter"
    @leave="leave"
  >
    <slot></slot>
  </TransitionGroup>
</template>

<script>
import Velocity from "velocity-animate";

export default {
  name: "StaggeredFadeTransition",
  props: {
    tag: {
      type: String,
      default: "ul",
    },
    className: {
      type: String,
      default: "",
    },
    delay: {
      type: Number,
      default: 150,
    },
  },
  methods: {
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      var delay = el.dataset.index * this.delay;
      setTimeout(function () {
        Velocity(el, { opacity: 1 }, { complete: done });
      }, delay);
    },
    leave(el, done) {
      var delay = el.dataset.index * this.delay;
      setTimeout(function () {
        Velocity(el, { opacity: 0 }, { complete: done });
      }, delay);
    },
  },
};
</script>
